import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from 'styles/app-styles'
import { ModalContent_s } from 'components/modal/modal-styles'

export const CreateSnapshotForm_s = styled.div`
  font-size: 16px;
  hr {
    border-top: 1px solid ${Colors.towerGrey};
    border-bottom: none;
    margin: 20px 0;
  }
  input[type="checkbox"]{
    margin-right: 5px;
  }
  textarea {
    border: 1px solid ${Colors.towerGrey};
    border-radius: 2px;
    font-size: 14px;
    margin-bottom: 10px;
    padding: 5px;
    width: 100% !important;
  }
  div:first-child {
    display: flex;
    flex-direction: column;
  }
  div:last-child {
    display: flex;
    justify-content: space-between;
  }
`

export const Snapshot_s = styled(DataTable_s)`
  .p-paginator {
    bottom: 0;
  }
  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }
  .download-icon svg {
    heigth: 18px;
    margin-left: 28px;
    width: 18px;
    .st0 {
      fill: ${Colors.blackPearl};
    }
  }
  .share-icon svg {
    heigth: 18px;
    margin: 5px 0 0 15px;
    width: 18px;
    .cls-1 {
      fill: ${Colors.blackPearl};
    }
  }
  tbody > tr > td:first-child {
    padding-left: 15px;
  }
  tbody > tr > td:nth-child(n+2):nth-child(-n+4) {
    padding-left: 5px;
  }
  ${ModalContent_s} > p {
    overflow-wrap: break-word;
  }
`

export const UploadSnapshot_s = styled.div`
  
`